<template>
  <div>
    <date-range-select />
    <b-tabs>
      <b-tab active>
        <template #title>
          <b-spinner v-if="loadingDisplay" type="grow" small />
          <strong>Overview</strong>
        </template>
        <p class="p-3">
          <overview
            ref="insights"
            :corner="corner"
            :user="user"
            :listing="listing"
          />
        </p>
      </b-tab>
      <b-tab>
        <template #title>
          Activity
        </template>
        <div class="p-3">
          <activity
            ref="activity"
            :corner="corner"
            :user="user"
            :listing="listing"
          />
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          Geographical
        </template>
        <div class="p-3">
          <geographical
            ref="geographical"
            :corner="corner"
            :user="user"
            :listing="listing"
          />
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          Customize
        </template>
        <div class="p-3">
          Set-Up and Customize. This is where you will set up your resource
          block.
          <ul>
            <li>Display On/Off</li>
            <li>Name App</li>
          </ul>
          <slot name="settings"></slot>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import Overview from "./overview";
import Activity from "./activity";
import Geographical from "./geographical";
import DateRangeSelect from "@/components/dateRangeSelect";

export default {
  name: "BaseResourceModal",
  components: {
    Overview,
    Activity,
    Geographical,
    DateRangeSelect
  },
  props: {
    corner: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    listing: {
      type: Object,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingDisplay: false
    };
  }
};
</script>
